export default "__VITE_ASSET__c62cf0ce__"